import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const BottomOrderBar = ({ onPlaceOrder, preCart, CreateOrderApi, paymentOption }) => {
  const totalCount =
    preCart?.length > 0 && preCart.reduce((total, item) => total + item.count, 0);

  const totalAmount =
    preCart?.length > 0 &&
    preCart.reduce((sum, item) => sum + item.amount * item.count, 0);

  // -------- CONDITIONS ----------
const walletBalance = paymentOption?.[3]?.balance || 0;
const isInsufficient = totalAmount > walletBalance;


  const bgColor = isInsufficient ? "#8A8A8A" : "#0C9B37";
  const textColor = "#FFFFFF";
  const rightLabel = isInsufficient ? "Insufficient Balance" : "Place Order";

  return (
    <Box sx={{ p: 1.5 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: bgColor,
          px: 2,
          py: 1.3,
          borderRadius: "18px",
          cursor: isInsufficient ? "not-allowed" : "pointer",
          opacity: isInsufficient ? 0.9 : 1,
        }}
        onClick={() => {
          if (!isInsufficient) onPlaceOrder();
        }}
      >
        {/* LEFT SIDE */}
        <Typography
          sx={{
            color: textColor,
            fontWeight: 600,
            fontSize: "16px",
            opacity: isInsufficient ? 0.8 : 1,
          }}
        >
          {totalCount} Item{totalCount > 1 ? "s" : ""} (₹{totalAmount})
        </Typography>

        {/* DIVIDER */}
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            borderColor: "rgba(255,255,255,0.5)",
            mx: 2,
          }}
        />

        {/* RIGHT SIDE */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            color: textColor,
            fontWeight: 600,
          }}
          onClick={(e) => {
            e.stopPropagation();
            if (!isInsufficient) CreateOrderApi();
          }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
            {rightLabel}
          </Typography>

          {!isInsufficient && (
            <ArrowForwardIosIcon sx={{ fontSize: "16px", ml: 0.5 }} />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default BottomOrderBar;
